import { useI18n } from 'vue-i18n';
import type { Airflow } from '@aviata/platform-types';
import { useBooking } from '@aviata/booking-composable';
import { controllerModel } from 'shared';

import { api } from '@/shared/api';
import { sentryModel } from '@/shared/model';

export function useProductsPageBooking() {
  const modal = controllerModel.useModal();
  const { t } = useI18n();

  const booking = useBooking({
    createOrder(payload: Airflow.Order.Payload.Entity) {
      return api.airflow.createOrder(payload).then(({ data }) => data);
    },
    validateOrder(payload: Airflow.Order.Payload.Entity) {
      return api.airflow.validateOrderData(payload).then(({ data }) => data);
    },
    onDoubleBookingError(error) {
      modal.show('booking-double-booking-modal', {
        message: error.message,
        title: t('contacts.errors.doubleBooking.title'),
        orderId: error.order_id,
      });

      sentryModel.captureException(
        sentryModel.getReadableError(
          'Booking error: double booking',
          new Error(error.message),
        ),
        { extra: { message: error.message } },
      );
    },
    onOfferExpiredError(error) {
      modal.show('booking-expired-error-modal', {
        title: t('contacts.errors.expiredOffer.title'),
        message: error.message,
      });
      sentryModel.captureException(
        sentryModel.getReadableError(
          'Booking error: offer expired',
          new Error(error.message),
        ),
        { extra: { message: error.message } },
      );
    },
  });

  return { booking, modal };
}
